<script setup lang="ts">
const { isAuthenticated } = storeToRefs(useAuthStore());
const { isModalPasswordOpen } = storeToRefs(useUserActivityStore());
const { resetIsModalPasswordOpen } = useUserActivityStore();
</script>

<template>
  <BaseModal
    v-if="isAuthenticated"
    v-model="isModalPasswordOpen"
    :custom-class-modal="$style.passwordDialog"
    :width="480"
    @close="resetIsModalPasswordOpen"
  >
    <div :class="$style.modalPassword">
      <div :class="$style.title">
        🔐 {{ $t('account.security.modal_password.title') }}
      </div>

      <div :class="$style.description">
        {{ $t('account.security.modal_password.description') }}
      </div>

      <div :class="$style.tip">
        ⏱️ {{ $t('account.security.modal_password.tip') }}
      </div>

      <UserAccountSecurityPassword
        ref="passwordRef"
        :button-text="$t('account.security.modal_password.button_text')"
        :only-form="true"
      />

      <button
        :class="$style.btnCancel"
        @click="resetIsModalPasswordOpen"
      >
        {{ $t('account.security.modal_password.button_cancel') }}
      </button>
    </div>
  </BaseModal>
</template>

<style module lang="postcss">
.passwordDialog {
  @apply z-[900];
}

.modalPassword {
  @apply flex flex-col gap-2 p-8 text-auth-texts;

  .title {
    @apply text-lg md:text-xl font-bold p-1 pt-0;
  }

  .description {
    @apply text-sm font-medium text-auth-texts/70 p-1;
  }

  .tip {
    @apply text-sm font-medium p-1 pb-6 mb-2 border-b border-auth-texts/20 border-dashed;
  }

  .btnCancel {
    @apply text-xs font-medium text-auth-texts/50 mx-2 mt-3 pb-1 mr-auto border-b border-auth-texts/30 border-dashed;
  }
}
</style>
